<template>
  <page>
    <div class="page-title">存款管理</div>
    <div class="page-content" style="padding: 0">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="存款中" name="pending">
          <DepositPendingTab @update="handleUpdate"></DepositPendingTab>
        </el-tab-pane>
        <el-tab-pane label="历史记录" name="history">
          <DepositHistoryTab @update="handleUpdate"></DepositHistoryTab>
        </el-tab-pane>
        <el-tab-pane label="存款档位设置" name="tier">
          <ManageDepositTierTab @update="handleUpdate"></ManageDepositTierTab>
        </el-tab-pane>
      </el-tabs>
    </div>
  </page>
</template>

<script>
// 引入标签页组件
import DepositHistoryTab from './components/ManageDepositHistoryTab.vue'
import DepositPendingTab from './components/ManageDepositPendingTab.vue'
import ManageDepositTierTab from './components/ManageDepositTierTab.vue'

export default {
  name: 'AdminFinanceDepositManage',
  components: {
    DepositPendingTab,
    DepositHistoryTab,
    ManageDepositTierTab,
  },
  data() {
    return {
      // 当前激活的标签页
      activeTab: 'pending',
    }
  },
  methods: {
    // 处理子组件更新事件
    handleUpdate() {
      // this.$message.info('数据已更新')
    },
  },
}
</script>

<style scoped>
.page-content :deep(.el-tabs__item) {
  padding: 0 20px !important;
}
</style>
